import { Localization } from "../../../OW.Remoting/Remoting/Localization";
import { Edit } from "../../UI.BaseControls/Edit";
import { registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { DropDownMenuItem } from "./DropDownMenuItem";

export class DropDownTextEditItem extends DropDownMenuItem {
    public isClickable: boolean = false;

    private _editElement: Edit;

    public get isEnabled(): boolean {
        return !this.classList.contains("disabled");
    }

    public set isEnabled(val: boolean) {
        this.classList.toggle("disabled", !val);
    }

    public get editElement(): Edit {
        return this._editElement;
    }

    public override focus(): void {
        this._editElement.focus();
    }

    protected override _constructor(): void {
        super._constructor();

        //this.Priority = ;
        //this.locKey = locKey;
        this.visible = true;
        //if (subMenu) this.Submenu = subMenu;
    }

    protected override _createElement(): void {
        this.classList.add("DropDownMenuItem", "TextItem");

        this._editElement = new Edit();

        this._createIconElement();

        if (this._locKey) {
            Localization.getTextPromise(this._locKey).then((locItem) => {
                this._captionElement.textContent = locItem;
            });
        }

        this.appendChild(this._iconElement);
        this.appendChild(this._editElement);

        this._setListener();
    }

    protected override _createCaptionElement(): void {
        this._captionElement = document.createElement("div");
        this._captionElement.classList.add("Caption");

        if (this._locKey) {
            Localization.getTextPromise(this._locKey).then((locItem) => {
                this._captionElement.textContent = locItem;
            });
        }
    }

    protected override _setListener(): void {
        this.registerEventListener("click", (e: MouseEvent) => {
            if (e.button === 0) {
                e.stopImmediatePropagation();
            }
        });
    }

    public override dispose(): void {
        super.dispose();
    }
}

registerCustomElement("tsc-DropDownTextEditItem", DropDownTextEditItem);
